import { ApiClient } from "~/api/api-client";
import { useCurrentUserStore } from "~/modules/common/store/useCurrentUserStore";

import { useAuthStore } from "./authStore";

export const authService = {
  logout() {
    useAuthStore.setState({ isLoggedIn: false });
    useCurrentUserStore.setState({ currentUser: undefined });

    // 🔥 Clear cookies (access + refresh)
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date(0).toUTCString() + ";path=/");
    });

    // 🔥 Clear browser storage
    localStorage.clear();
    sessionStorage.clear();

    // 🔥 Hard redirect (bypass Remix state)
    window.location.href = "/auth/login";


  },

  async refreshToken() {
    return ApiClient.api.authControllerRefreshTokens();
  },
};
